/* istanbul ignore file */
import { getUser } from 'utils/user';
import { Platform, AmplitudeWebMobileMode } from './constants';

const MOBILE_REGEX = /Mobi/;

const isMobile = () => navigator.userAgent.match(MOBILE_REGEX) !== null;

const getPlatform = () => isMobile() ? Platform.mobile : Platform.desktop;

const getWebMobileMode = () =>
  window.matchMedia && window.matchMedia('(display-mode: standalone)').matches ?
    AmplitudeWebMobileMode.homeScreen :
    AmplitudeWebMobileMode.browser;

const getUserProperties = () => ({
  platform: getPlatform(),
  web_mobile_mode: getWebMobileMode(),
});

const setAmplitudeUserProperties = (amplitudeInstance) => {
  amplitudeInstance.setUserId(getUser().user_id);
  amplitudeInstance.setUserProperties(getUserProperties());
  amplitudeInstance.setVersionName(process.env.BUILD);
};

const createMainEventProperties = (pageName) => ({
  uri: window.location.href,
  current_page: pageName,
  referrer: window.document.referrer,
});

export {
  isMobile,
  getPlatform,
  getWebMobileMode,
  setAmplitudeUserProperties,
  createMainEventProperties,
};
